"use client";
import { jsxs as t, jsx as i } from "react/jsx-runtime";
const o = ({
  title: e,
  titleId: n,
  desc: l,
  descId: a,
  ...r
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "-.5 -.5 16 16",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": n,
    "aria-describedby": a,
    ...r,
    children: [
      e ? /* @__PURE__ */ i("title", { id: n, children: e }) : null,
      l === void 0 ? /* @__PURE__ */ i("desc", { id: a, children: `
    Shopping Cart Simple Streamline Icon: https://streamlinehq.com
  ` }) : l ? /* @__PURE__ */ i("desc", { id: a, children: l }) : null,
      /* @__PURE__ */ i("path", { d: "M6.2327 13.0758c0 .7804-.8448 1.2682-1.5207.878s-.6758-1.3657 0-1.756c.1542-.089.329-.1358.507-.1358.5598 0 1.0137.454 1.0137 1.0138m5.5758-1.0138c-.7804 0-1.2681.8449-.878 1.5207.3903.6759 1.3658.6759 1.756 0 .089-.1541.1358-.329.1358-.5069 0-.5599-.4539-1.0138-1.0138-1.0138m3.023-7.9747-1.6246 5.847a1.5245 1.5245 0 0 1-1.4617 1.114H5.4825a1.5245 1.5245 0 0 1-1.4674-1.114L1.7923 1.9243H.657c-.3902 0-.6341-.4224-.439-.7604A.507.507 0 0 1 .657.9104h1.5207a.507.507 0 0 1 .4885.3713l.6007 2.1632H14.343c.3352-.0001.5782.3194.4885.6424m-1.1557.3713H3.5488L4.994 9.6632a.507.507 0 0 0 .4885.3713h6.2627a.507.507 0 0 0 .4885-.3713Z" })
    ]
  }
);
export {
  o as default
};
